<style scoped>
.el-main {
    background-color: #f5f7f9;
}

.el-header,
.el-footer {
    background-color: white;
    box-sizing: border-box;
    border-bottom: 1px solid #f5f1f1;
}

.el-container {
    height: 100%;
}
</style>

<template>
    <el-container>
        <el-header>
            <navtop></navtop>
        </el-header>

        <el-container>
            <leftnav></leftnav>
            <el-main>
                <router-view/>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import app from '@/App.vue';
import navtop from "@/components/nav-top.vue";
import leftnav from "@/components/nav.vue";

export default {
    components: {
        navtop,
        leftnav
    },
    data() {
        return {
            name: 'paitedao'
        };
    },
    methods: {
        
    },
    beforeCreate(){
        var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        if (userInfo != null && userInfo.token != '' && userInfo.token != undefined) {
            app.globalData.userInfo = userInfo;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/layout.vue